import './styles.scss'

import Skeleton from 'react-loading-skeleton'

import { ChevronRightIcon } from '@/components/Icons'

interface CategoryItemProps {
  loading?: boolean
  id: number
  name: string
  subCats?: {
    id: number
    name: string
    subCats?: {
      id: number
      name: string
      subCats?: {
        id: number
        name: string
      }[]
    }[]
  }[]
  shouldShowSubCatsDrawer?: boolean
  shouldShowAccsDetSubCatsDrawer?: boolean
  shouldShowAccsDetSubSubCatsDrawer?: boolean
  onClick?: (
    id: number,
    name: string,
    subCats: {
      id: number
      name: string
      subCats?: {
        id: number
        name: string
        subCats?: {
          id: number
          name: string
        }[]
      }[]
    }[],
    shouldShowSubCatsDrawer: boolean,
    shouldShowAccsDetSubCatsDrawer: boolean,
    shouldShowAccsDetSubSubCatsDrawer: boolean,
  ) => void
}

function CategoryItem(props: CategoryItemProps) {
  const {
    loading = false,
    id,
    name,
    subCats,
    shouldShowSubCatsDrawer = false,
    shouldShowAccsDetSubCatsDrawer = false,
    shouldShowAccsDetSubSubCatsDrawer = false,
    onClick,
  } = props

  const onItemClick = () => {
    onClick?.(
      id,
      name,
      subCats,
      shouldShowSubCatsDrawer,
      shouldShowAccsDetSubCatsDrawer,
      shouldShowAccsDetSubSubCatsDrawer,
    )
  }

  return loading
    ? (
      <div className="category-item category-item--loading">
        <Skeleton />
        <ChevronRightIcon />
      </div>
    )
    : (
      <button
        className="category-item__wrapper--mobile"
        type="button"
        onClick={onItemClick}
      >
        <div className="category-item">
          <span>{name}</span>
          <ChevronRightIcon />
        </div>
      </button>
    )
}

export default CategoryItem
